
export enum MailingMessageStatus {
    /**
     * Nachricht ist geplant für baldige Versendung oder Terminversendung.
     */
    scheduled = "scheduled",
    /**
     * Nachricht wird versendet.
     */
    sending = "sending",
    /**
     * Nachricht wurde fertig versendet.
     */
    complete = "complete"
}

export const MailingMessageStatusNames = {
    scheduled: "Geplant",
    sending: "Wird gesendet...",
    complete: "Vollständig gesendet"
};
